import {
  Box,
  Divider,
  DropdownMenu,
  externalRedirect,
  Icon,
  Link,
  Menu,
  MenuItem,
  PrivacyIcon,
  ThemeSwitcher,
} from '@tcp-base/design-system';

import './UserPanel.scss';
import { UserPanelModel } from './UserPanel.model';
import { COMPANY_REFERENCE_LINKS } from '../../config/external.config';
import UserAvatar from '../user-avatar/index.component';
import { MouseEventHandler } from 'react';
import { ModusWcMenuItem } from '@trimble-oss/moduswebcomponents/components/modus-wc-menu-item';

export const UserPanelViewer: React.FC<UserPanelModel> = ({
  given_name,
  family_name,
  email,
  isPanelMenuVisible = false,
  isProfileLoaded,
  toggleLegalContentVisibility,
  isLegalContentEnabled,
  togglePanelVisibility,
  links,
  navigateToLink,
  signOut,
}) => {
  return (
    <span
      className='user-panel-wrapper'
      style={{ visibility: isProfileLoaded ? 'visible' : 'hidden' }}
    >
      <DropdownMenu
        menuVisible={isPanelMenuVisible}
        customClass={'user-panel'}
        buttonColor='tertiary'
        buttonVariant='borderless'
        buttonShape='circle'
        buttonSize='lg'
        onMenuVisibilityChange={togglePanelVisibility}
      >
        <div slot='button' color='transparent'>
          <UserAvatar size='md' />
        </div>
        <div slot='menu'>
          <Box className='menu'>
            <div className='section user-base'>
              <div className='menu-user-avatar'>
                <UserAvatar size='xl' />
              </div>
              <div className='user-content'>
                {given_name} {family_name}
              </div>
              <div className='user-content'>{email}</div>
              <div>
                <Link href={links.profile} target='_blank'>
                  Manage my Trimble ID
                </Link>
              </div>
            </div>
            <Divider customClass='no-space hide' />
            {/* Hiding this part temporarily for external workflow until we have the seggregation of internal and external workflows */}
            <div className='menu section hide'>
              <MenuItem label='Switch to' value='iot' className='header' />
              <MenuItem
                label='IOT Support Portal'
                value={links.iotSupport}
                onClick={() => externalRedirect(links.iotSupport)}
              />

              <MenuItem
                label='Transactional Email'
                value={links.transactionalEmail}
                onClick={() => externalRedirect(links.transactionalEmail)}
              />
            </div>
            <Divider customClass='no-space' />
            <Menu className='menu section'>
              <MenuItem
                label='Legal'
                value='iot'
                className='header'
                onClick={toggleLegalContentVisibility}
              >
                <Icon
                  slot='start-icon'
                  customClass={isLegalContentEnabled ? 'dropdown_enabled' : 'dropdown_disabled'}
                  name={'expand_less'}
                />
              </MenuItem>
              <div>
                {isLegalContentEnabled && (
                  <div>
                    <MenuItem
                      label='Privacy Notice'
                      value={COMPANY_REFERENCE_LINKS.PRIVACY_NOTICE_URL}
                      onClick={navigateToLink as unknown as MouseEventHandler<ModusWcMenuItem>}
                    />
                    <MenuItem
                      label='Terms of Use'
                      value={COMPANY_REFERENCE_LINKS.TERMS_OF_USE_URL}
                      onClick={navigateToLink as unknown as MouseEventHandler<ModusWcMenuItem>}
                    />
                    <MenuItem
                      label='CA Notice at Collection'
                      value={COMPANY_REFERENCE_LINKS.CA_NOTICE_AT_COLLECTION_URL}
                      onClick={navigateToLink as unknown as MouseEventHandler<ModusWcMenuItem>}
                    />
                    <MenuItem
                      label='Your Privacy Choices (US)'
                      value={COMPANY_REFERENCE_LINKS.YOUR_PRIVACY_CHOICES_US_URL}
                      onClick={navigateToLink as unknown as MouseEventHandler<ModusWcMenuItem>}
                    >
                      <PrivacyIcon slot='start-icon' className='privacy-icon' />
                    </MenuItem>
                  </div>
                )}
              </div>
              <MenuItem label='Sign out' value='logout' onClick={signOut}>
                <Icon slot='start-icon' name='sign_out' />
              </MenuItem>
            </Menu>
            <Divider customClass='no-space' />
            <div className='theme-switcher'>
              <ThemeSwitcher theme={'light'} />
            </div>

            <div className='user-base footer'>&copy; {new Date().getFullYear()}, Trimble Inc.</div>
          </Box>
        </div>
      </DropdownMenu>
    </span>
  );
};
